import { JsonObject, JsonProperty } from 'json2typescript';
import { EmptyControl } from '@hvlng/framework-bff/core';
import { HvlDateConverter } from '@hvlng/framework-bff/util';

@JsonObject('KovanHrOrganizationSharedModel')
export class OrganizationSharedModel{

    @EmptyControl()
	@JsonProperty('objectDefinitionId', Number, true)
	objectDefinitionId: number = null;

    @EmptyControl()
	@JsonProperty('objectDefinitionUuid', String, true)
	objectDefinitionUuid: string = null;

    @EmptyControl()
	@JsonProperty('objectCode', String, true)
	objectCode: string = null;

    @EmptyControl()
	@JsonProperty('objectDefinitionName', String, true)
	objectDefinitionName: string = null;

    @EmptyControl()
	@JsonProperty('shortName', String, true)
	shortName: string = null;

    @EmptyControl()
	@JsonProperty('beginDate', HvlDateConverter, true)
	beginDate: Date = null;

    @EmptyControl()
	@JsonProperty('endDate', HvlDateConverter, true)
	endDate: Date = null;

    @EmptyControl()
	@JsonProperty('objectStatusUuid', String, true)
	objectStatusUuid: string = null;

    @EmptyControl()
	@JsonProperty('objectStatusId', Number, true)
	objectStatusId: number = null;

    @EmptyControl()
	@JsonProperty('objectStatusText', String, true)
	objectStatusText: string = null;

    @EmptyControl()
	@JsonProperty('managerPeopleId', Number, true)
	managerPeopleId: number = null;

    @EmptyControl()
	@JsonProperty('managerPeopleUuid', String, true)
	managerPeopleUuid: string = null;

    @EmptyControl()
	@JsonProperty('managerName', String, true)
	managerName: string = null;

    @EmptyControl()
	@JsonProperty('managerSurname', String, true)
	managerSurname: string = null;

    @EmptyControl()
	@JsonProperty('managerRegNum', String, true)
	managerRegNum: string = null;

    @EmptyControl()
	@JsonProperty('location', String, true)
	location: string = null;

    @EmptyControl()
	@JsonProperty('parentId', Number, true)
	parentId: number = null;

    @EmptyControl()
	@JsonProperty('active', Boolean, true)
	active: boolean = null;
}
